import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sendFeedback: {
    description: 'Button label to open the feedback modal',
    defaultMessage: 'Send Feedback',
    id: 'FK4srx',
  },
});
